const eol = require("eol");
/* Takes plaintext with no formatting */
module.exports = function getLongestLine(text){
    return eol.split(text).sort((lineA, lineB)=>{
        return lineB.length - lineA.length;
    })[0];
}